export const SET_AUTHENTICATION_STATE = 'SET_AUTHENTICATION_STATE'
export const RESET_AUTHENTICATION_STATE = 'RESET_AUTHENTICATION_STATE'
export const SET_AUTHENTICATION_STATE_FORCE_CLOSE = 'SET_AUTHENTICATION_STATE_FORCE_CLOSE'
